import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import './ResultFilter.scss';
import { Button, EButtonType, Input, EInputType } from '@repo/apg-ui';
import classNames from 'classnames';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/new/close.svg';
import { ReactComponent as CollapseIcon } from '../../../../assets/icons/new/chev_down.svg';
import { ReactComponent as ExpandIcon } from '../../../../assets/icons/new/chev_up.svg';
import { Accordion, useAccordionButton } from 'react-bootstrap';
import { ReactComponent as RedEye } from '../../../../assets/icons/red_eye.svg';
import { PartiallyIntegratedUserDataEC } from '../../../../reducers/app';

const CustomToggle = ({ children, eventKey }) => {
  const decoratedOnClick = useAccordionButton(eventKey);

  return <div onClick={decoratedOnClick}>{children}</div>;
};

interface Props {
  checkedFilters: any;
  selectFilter: any;
  clearFilters: any;
  setExpandedFilters: any;
  expandedFilters: any;
  productFilters: any;
  filterVisibility: boolean;
  setFilterVisibility: (value: boolean) => void;
  setIsFilterOpen: (value: any) => void;
  userDataEC: PartiallyIntegratedUserDataEC;
}

export const ResultFilter = ({
  checkedFilters,
  selectFilter,
  clearFilters,
  setExpandedFilters,
  expandedFilters,
  productFilters,
  filterVisibility,
  setFilterVisibility,
  setIsFilterOpen,
  userDataEC: { format, target, attribute, commspace },
}: Props) => {
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth < 767);
  const [isFilterIconTextHidden, setIsFilterIconTextHidden] = React.useState<boolean>(window.innerWidth < 1440);
  // const [priceRange, setPriceRange] = React.useState<{ min: number; max: number }>({ min: 1800, max: 8500 });

  const handleResize = () => {
    if (window.innerWidth < 767) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }

    if (window.innerWidth < 1430) {
      setIsFilterIconTextHidden(true);
    } else {
      setIsFilterIconTextHidden(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isFilterChecked = (filter: any) => checkedFilters.includes(filter);

  const isFilterExpanded = (filter: any) => expandedFilters.includes(filter);

  const getFilteredValuesLabel = (filterName: string) => {
    if (filterName === 'format') {
      return format.length > 0 ? ` (${format.length})` : '';
    } else if (filterName === 'target') {
      return target.length > 0 ? ` (${target.length})` : '';
    } else if (filterName === 'attribute') {
      return attribute.length > 0 ? ` (${attribute.length})` : '';
    } else if (filterName === 'commspace') {
      return commspace.length > 0 ? ` (${commspace.length})` : '';
    }
  };

  const toggleFilter = (filter: any) => {
    if (expandedFilters.includes(filter)) {
      setExpandedFilters(expandedFilters.filter((f: any) => f !== filter));
    } else {
      setExpandedFilters([...expandedFilters, filter]);
    }
  };

  return (
    <div className={isMobile ? 'w-100 h-100 filter-wrapper' : 'me-24'}>
      <div
        className={classNames('font-24 font-bold text-body', {
          '': !isMobile,
          'filter-title d-flex flex-row align-items-center justify-content-between border-bottom px-4 py-24': isMobile,
        })}
      >
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex flex-row align-items-center'>
            {filterVisibility && !isMobile && (
              <div
                className='cursor-pointer pe-2'
                onClick={() => {
                  setFilterVisibility(false);
                }}
              >
                <RedEye />
              </div>
            )}
            <FormattedMessage id='ec.journey2.filters.title' defaultMessage={'Filter'} />
          </div>
          {!isMobile && (
            <div className='cursor-pointer font-16 text-red' onClick={() => clearFilters()}>
              <FormattedMessage id='ec.journey2.filters.clearAll' defaultMessage={'Alles löschen'} />
            </div>
          )}
        </div>

        {isMobile && (
          <div className='d-flex align-items-center justify-content-between'>
            <div className='cursor-pointer font-14 text-red mr-4' onClick={() => clearFilters()}>
              <FormattedMessage id='ec.journey2.filters.clearAll' defaultMessage={'Alles löschen'} />
            </div>
            <div className='close-icon ms-3 cursor-pointer' onClick={() => setIsFilterOpen(false)}>
              <CloseIcon />
            </div>
          </div>
        )}
      </div>

      <div className={isMobile ? 'px-4 pb-4 filter-items' : ''}>
        <Accordion activeKey={expandedFilters} alwaysOpen>
          {/*price range hard coded filter*/}
          {/*<CustomToggle eventKey="price">*/}
          {/*    <div*/}
          {/*        className="d-flex align-items-center justify-content-between mt-24 cursor-pointer"*/}
          {/*        onClick={() => toggleFilter('price')}*/}
          {/*    >*/}
          {/*        <div className="font-16 font-bold text-body">Price Range</div>*/}
          {/*        <div className="font-12 font-bold text-red">*/}
          {/*            {isFilterExpanded('price') ? (*/}
          {/*                <FormattedMessage id="ec.journey2.filters.collapse" defaultMessage={'Collapse -'} />*/}
          {/*            ) : (*/}
          {/*                <FormattedMessage id="ec.journey2.filters.expand" defaultMessage={'Expand +'} />*/}
          {/*            )}*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*</CustomToggle>*/}

          {/*<Accordion.Collapse eventKey="price">*/}
          {/*    <div className="filters__item__content">*/}
          {/*        <div key={'input_price_range'} className="filters__item__content__item">*/}
          {/*            <RangeSlider priceRange={priceRange} setPriceRange={setPriceRange} />*/}
          {/*        </div>*/}
          {/*    </div>*/}
          {/*</Accordion.Collapse>*/}

          {productFilters?.map((filter, idx) => {
            const isExpanded = isFilterExpanded(filter.selectfield);
            return (
              <div key={idx} className='filters__item'>
                <CustomToggle eventKey={filter.selectfield}>
                  <div
                    className='d-flex align-items-center justify-content-between mt-24 cursor-pointer filter-title'
                    onClick={() => toggleFilter(filter.selectfield)}
                  >
                    <div className='font-16 font-bold filter-label'>
                      <span>{filter.title}</span>
                      <span className='text-red'>{getFilteredValuesLabel(filter.selectfield)}</span>
                    </div>
                    {isExpanded ? (
                      <div className='font-12 font-bold filter-icon'>
                        {!isFilterIconTextHidden && (
                          <FormattedMessage id='ec.journey2.filters.collapse' defaultMessage={'Schliessen'} />
                        )}
                        <CollapseIcon />
                      </div>
                    ) : (
                      <div className='font-12 font-bold filter-icon'>
                        {!isFilterIconTextHidden && (
                          <FormattedMessage id='ec.journey2.filters.expand' defaultMessage={'Öffnen'} />
                        )}
                        <ExpandIcon />
                      </div>
                    )}
                  </div>
                </CustomToggle>

                <Accordion.Collapse eventKey={filter.selectfield}>
                  <div className='filters__item__content'>
                    {filter.values.map((value, idy) => {
                      if (value.subnodes?.length > 0) {
                        return (
                          <div key={idy}>
                            <div className='font-14 font-bold text-body mt-3'>{value.label}</div>
                            <div className='py-3'>
                              {value.subnodes.map((subnode, idz) => {
                                return (
                                  <div key={'sub_' + idz} className='filters__item__content__item'>
                                    <Input
                                      inputType={EInputType.Checkbox}
                                      type={'checkbox'}
                                      checkboxLabel={subnode.label}
                                      id={subnode.code}
                                      name={subnode.code}
                                      inputWrapperClass={classNames('mt-3', {
                                        'grayed-out': subnode.count === 0,
                                      })}
                                      onChange={() => selectFilter(subnode.code, filter.selectfield)}
                                      checked={isFilterChecked(subnode.code)}
                                    />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      }
                      return (
                        <div key={'input_' + idy} className='filters__item__content__item'>
                          <Input
                            inputType={EInputType.Checkbox}
                            type={'checkbox'}
                            id={value.code}
                            checkboxLabel={value.label}
                            name={value.code}
                            inputWrapperClass={classNames({
                              'grayed-out': value.count === 0,
                            })}
                            onChange={() => selectFilter(value.code, filter.selectfield)}
                            checked={isFilterChecked(value.code)}
                          />
                        </div>
                      );
                    })}
                  </div>
                </Accordion.Collapse>
              </div>
            );
          })}
        </Accordion>
      </div>

      {isMobile && (
        <div className='filter-action d-flex justify-content-center p-4 gap-4'>
          {checkedFilters.length > 0 && (
            <Button className='mt-0' buttonType={EButtonType.BasicLink} onClick={clearFilters}>
              Clear all
            </Button>
          )}
          <Button
            onClick={() => setIsFilterOpen(false)}
            className={'w-100 mt-0'}
            buttonType={EButtonType.InvertedPillMedium}
          >
            Apply filters
          </Button>
        </div>
      )}
    </div>
  );
};
